import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { salesCalculateReportMemo } from 'lib/api/sales';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { dataConverter } from 'lib/commonLib';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import NewButton from 'components/molecules/NewButton';
import queryString from 'query-string';
import CalculateModal from './CalculateModal';

const StatisticsHistory = ({ location }) => {
  const { t } = useTranslation();
  let initParams = {
    adutSvcTpCode: '',
    statsMth: '',
  };
  let initModal = {
    open: false,
    type: null,
    params: {},
    modalTitle: '',
    confirmBtnTitle: '',
    message: '',
  };
  const adutSvcTpCodeList = [
    { label: '전체', value: 'all' },
    { label: '모비온', value: '01' },
    { label: '매체', value: '02' },
    { label: '외부연동', value: '03' },
  ];

  const convertKeys = ['statsMth', 'adutSvcTpCode'];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );

  initParams = {
    ...initParams,
    ...newInitParams,
  };
  initModal = {
    ...initModal,
    params: {
      ...newInitParams,
    },
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [modal, setModal] = useState(initModal);
  const [reFetch, setReFetch] = useState(false);

  console.log('params', params);
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const getModalParam = (newParams) => {
    if (JSON.stringify(modal) !== JSON.stringify(newParams)) {
      setModal(newParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  /**
   * 테이블 상태를 갱신
   * @param status
   */
  const handleReFetch = (status) => {
    setReFetch(status);
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    getModalParam(newModal);
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e, data) => {
    const { name } = e.currentTarget;
    let newModal = { ...initModal };

    if (name === 'historyAdd') {
      newModal = {
        ...newModal,
        open: true,
        type: name,
        modalTitle: '히스토리 관리',
        confirmBtnTitle: '확인',
        params: {
          ...modal.params,
          adutSvcTpCode: params['adutSvcTpCode'],
          statsMth: params['statsMth'],
          memo: '',
        },
      };
    } else if (name === 'historyEdit') {
      newModal = {
        ...newModal,
        open: true,
        type: name,
        modalTitle: '히스토리 관리',
        confirmBtnTitle: '수정',
        params: {
          ...modal.params,
          adutSvcTpCode: params['adutSvcTpCode'],
          statsMth: params['statsMth'],
          memo: data['MEMO'],
          no: data['NO'],
        },
      };
    }

    setModal(newModal);
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(-1, {
      id: 'memoEdit',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <>
            <NewButton
              name="historyEdit"
              title={t('히스토리 수정')}
              iconBtn
              icon="faEdit"
              onClick={(e) => handleModalOpen(e, data)}
              disableRipple
            />
          </>
        );
      },
    });
    return result;
  })();

  const customized = {
    ALT_DTTM: {
      makeHead: () => {
        return `변경일/시간`;
      },
      makeBody: (rowObj, headsMap) => {
        const roas = getHeadObj(headsMap, 'ALT_DTTM');
        return <>{makeRowColumn(rowObj['ALT_DTTM'], roas.type, roas.format)}</>;
      },
      bodyStyle: {
        textAlign: 'center',
        width: 200,
      },
      headStyle: {
        width: 200,
      },
    },
    MEMO: {
      makeBody: (rowObj, headsMap) => {
        const memo = getHeadObj(headsMap, 'MEMO');
        return <>{makeRowColumn(rowObj['MEMO'], memo.type, memo.format)}</>;
      },
      bodyStyle: {
        textAlign: 'left',
        borderRight: '1px solid #e5e8eb',
      },
    },
    memoEdit: {
      bodyStyle: {
        textAlign: 'center',
        width: 70,
      },
      headStyle: {
        width: 70,
      },
    },
    NO: {
      merged: true,
    },
    STATS_MTH: {
      merged: true,
    },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useSingleDate
          useMonthDate
          singleDateId={'statsMth'}
        />
        <FilterCollection
          label={t('구분')}
          name="adutSvcTpCode"
          params={params}
          value={params.adutSvcTpCode}
          type="select"
          list={adutSvcTpCodeList}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />

        <NewButton name="historyAdd" onClick={handleModalOpen}>
          {t('등록')}
        </NewButton>
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={salesCalculateReportMemo}
        params={params}
        getParam={getParam}
        customized={customized}
        useSearch={false}
        useTotal={false}
        reFetch={reFetch}
        addColumnList={addColumnList}
      />
      {modal.open === true && (
        <CalculateModal
          modal={modal}
          handleReFetch={handleReFetch}
          getModalParam={getModalParam}
          handleModalClose={handleModalClose}
        ></CalculateModal>
      )}
    </>
  );
};

export default withRouter(StatisticsHistory);
